import { NotificationService } from '../../_services/notification.service';
import { DomSanitizer } from '@angular/platform-browser'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from 'ng2-translate';
import { PostService } from '../../model/post.service';
import { FirebaseListObservable } from 'angularfire2/database-deprecated';
import {
  Component, OnInit, Input, ChangeDetectionStrategy, SimpleChanges, OnChanges, ViewChild,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Lightbox } from 'angular2-lightbox';
import { StoragePathPipe } from '../../_pipe/storage-path.pipe';
import { AlertService } from '../../_services/alert.service';
import { UserService } from '../../_services/user.service';
import { DatabaseSnapshot } from 'angularfire2/database-deprecated/interfaces';
import { MatDialog } from '@angular/material';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { CommentLoaderComponent } from '../../directive/comment-loader/comment-loader.component';
import { AngularFirestore } from 'angularfire2/firestore';
import { firestore } from 'firebase/app';
import { WeeklyPostsService } from '../../_services/weeklyPosts.service';
import { Http } from '@angular/http';
import { ApiService } from '../../_services/api.service';

@Component({
  selector: 'app-post-body',
  templateUrl: './post-body.component.html',
  styleUrls: ['./post-body.component.css'],
  providers: [PostService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
          ':enter', [
            style({ transform: 'translateX(-100%)', opacity: 0 }),
            animate('500ms', style({ transform: 'translateX(0)', 'opacity': 1 }))
          ]
        ),
        transition(
          ':leave', [
            style({ transform: 'translateX(0)', 'opacity': 1 }),
            animate('500ms', style({ transform: 'translateX(-100%)', 'opacity': 0 }))
          ]
        )])
  ]
})
export class PostBodyComponent implements OnInit, OnDestroy {
  message;
  testReply;
  show = false;
  friends: FirebaseListObservable<any[]>;
  comments: {};
  user: any;
  files: any[] = [];
  model: any[] = [];
  keywords = [];
  isSeen = true;
  isSilencedForMe = false;
  isSeenText = true;
  postFiles: any[] = [];
  likeLength: any;
  isLike: any;
  isLikeCount: number;
  isCommentCount: number;
  censorPhoto = false;
  userId = this.userService.getUid();
  private subscription: Subscription = new Subscription();
  subsc: Subscription;
  isMouseOver: boolean;
  _isLiked: boolean;
  _isComment: boolean;
  _isInMyFollowingPosts: boolean;
  _isRepost: boolean;
  maxLength = 200;
  textExposedHide = '...';
  isCollapsable = false;
  html: string;
  ipAddress: any;
  text: string;
  isPostProfile = false;
  firstPost = [];
  @Input() post: any;
  // @Input() firstPost: any;
  @Input() whichPage: any;
  @Input() recentPostsLength: any;
  @Output() reload = new EventEmitter();
  @ViewChild(CommentLoaderComponent) commentLoader: CommentLoaderComponent;
  constructor(
    private userService: UserService,
    public translate: TranslateService,
    private _lightbox: Lightbox,
    public modalService: NgbModal,
    private apiService: ApiService,
    private _http: Http,
    private afs: AngularFirestore,
    private postService: WeeklyPostsService,
    private postSw: PostService,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    public router: Router, private alertService: AlertService, private sanitizer: DomSanitizer, private cd: ChangeDetectorRef) {
    translate.setDefaultLang("tr");

    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user

    }));
    console.log(this.whichPage);



  }

  scroll() {
    try {
      this.commentLoader.commentText.nativeElement.scrollIntoView({ behavior: "smooth", block: "center" });
      this.commentLoader.focus();
    } catch (e) {

    }
  }
  isLoggedIn() {
    if (!this.userId)
      this.router.navigate(['/auth']);
  }

  ngOnDestroy() {

    this.subscription.unsubscribe();
    if (this.subsc) {
      this.subsc.unsubscribe();

    }

  }

  isSilencedUser(username) {
    try {
      let array = [];
      this.afs.collection('users').doc(this.user.id).collection('silencedUser').ref.get().then((data) => {
        if (!data.empty) {
          data.forEach(silencedUser => {
            array.push(silencedUser.data());

          })
        }
      })
      this.isSilencedForMe = !array.every((data: any) => username !== data.username);
      this.cd.markForCheck();

    } catch (e) {
      this.isSilencedForMe = false;
    }
  }

  ngOnInit() {

    if (this.whichPage == 'postProfile') {
      this.isPostProfile = true;
      this.apiService.sqlPost('corporate/keywordBrandProcedure4', { postKey: this.post.id }).map(res => res.json()).toPromise().then(data => {
        data.forEach(keyword => {

          this.keywords.push(keyword.keyword);
          console.log(this.keywords);
          this.cd.markForCheck();
        });
      });
      this.cd.markForCheck();
    }




    if (this.post) {
      this.isLikeCount = this.post.likes ? this.post.likes : 0;
      this.postFiles = this.post.files ? this.post.files : [];


    }
    if (this.router.url == `/post/${this.post.id}` && this.post.answers) {
      this.revisedPost();
      this.replyFormat();
      this.cd.markForCheck();

    }
    try {

      this.isSilencedUser(this.post.author.username);

      if (this.post) {

        this.cd.markForCheck();
        if (this.post.settings.isOnlyFriend) {
          this.subsc = this.userService.getFollowers().subscribe(followUser => {
            const isMyFriend = followUser.map(data => {
              return data.username;
            }).includes(this.post.author.username);

            if ((isMyFriend === true || this.post.author.username == this.user.username)) {
              this.isSeenText = true;
              this.cd.markForCheck();

            }
            else if ((isMyFriend === false)) {
              this.isSeenText = false;
              this.cd.markForCheck();

            }

          })





        }



      }
    } catch (e) {


    }

  }
  readMore2() {

  }
  readMore(data) {
    this.isCollapsable = true;
    this.html = data;

  }
  replyFormat() {
    this.post.answers.filter(a => {
      a.text = a.text.split('\n').join('<br/>');
    })

    this.testReply = this.post.answers;




  }
  revisedPost() {


    if (this.post.revisedPostKey) {
      this.afs.collection('posts').doc(this.post.revisedPostKey).ref.get().then((data => {
        this.firstPost.push(data.data());
        this.firstPost['id'] = this.post.revisedPostKey;
        this.cd.markForCheck();
      }));
      this.cd.markForCheck();


    }
    // this.userService.userLog('revised-post', this.ipAddress);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getIpAdress();


    try {
      if (changes.post.currentValue) {

        if (this.post.isCensor) {
          this.censorPhoto = true;
        }


        this.post = changes.post.currentValue;
        this.cd.markForCheck();
        this.isLiked().then((boolLike) => {
          this._isLiked = boolLike;
          this.cd.markForCheck();
        })
        this._isComment = this.isComment();
        this._isInMyFollowingPosts = this.isInMyFollowingPosts();
        this.isRepost().then((boolLike) => {
          this._isRepost = boolLike;
          this.cd.markForCheck();
        })
      }
    }
    catch (e) { }
  }

  open(content, ctrl) {
    if (this.user) {

      this.subscription.add(this.afs.collection('posts', ref => ref.where('author.username', '==', this.user.username))
        .valueChanges().subscribe(posts => {
          if (posts) {
            const myPosts = Object.values(posts).filter(post => post["modifyDate"] > Date.now() - 86400000);
            if (myPosts.length >= 20 && ctrl == 0) {
              this.alertService
                .error('Gerçekçi deneyimlerini paylaşabilmemiz için günlük yorum yapma hakkın 10 ile sınırlı, seni yarın burada bekliyor olacağız.')
            }
          }
        }))
      this.modalService.open(content, { backdrop: "static" });


    } else {
      this.router.navigate(["/auth"]);
    }
  }

  complaintPost(post) {
    if (!this.userId) {
      this.router.navigate(['/auth']);
      return;
    }
    this.afs.collection('complaints').doc(post.id).ref.get().then((snap => {
      if (!snap.exists) {
        this.afs.collection('complaints').doc(post.id).set({
          text: post.text,
          type: 'post-complaint',
          innerText: post.innerText,
          files: post.files ? post.files : null,
          profileImage: post.author.profileImage,
          modifyDate: post.modifyDate,
          complaintDate: Date.now(),
          order: -1 * Date.now(),
          firstname: post.author.firstname,
          lastname: post.author.lastname,
          username: post.author.username

        }).then(() => {
          this.afs.collection('complaints').doc(post.id).collection('users').doc(this.userId).set({
            username: this.user.username,
            firstname: this.user.firstname,
            lastname: this.user.lastname,
            key: this.user.id,
            modifyDate: Date.now()

          })
        })
      }
      else {
        this.afs.collection('complaints').doc(post.id).collection('users').doc(this.userId).set({
          username: this.user.username,
          firstname: this.user.firstname,
          lastname: this.user.lastname,
          key: this.user.id,
          modifyDate: Date.now()

        })

      }
    }))
    this.dialog.open(SaveMessageComponent, {
      width: '400px',
      data: {
        message: "Şikayetin iletilmiştir.",
        type: "update"
      }
    });
    this.userService.userLog('complaint-post', this.ipAddress);
  }

  addMyFavorites(post) {

    if (!this.userId) {
      this.router.navigate(['/auth']);
      return;
    }

    // let post: any = {};
    // Object.assign(post, _post);
    // let postKey = _post.$key;

    if (this.isInMyFollowingPosts()) {
      this.deleteFollowingPost(post);
    } else {
      // delete post.$key;

      let postFollowers = post["followers"] ? Array.from(post["followers"]) : [];
      postFollowers.push(this.userId);
      this.afs.collection('posts').doc(post.id).update({
        followers: postFollowers
      }).then(() => {
        this.afs.collection('users').doc(this.userId).update({
          followIngPostCount: this.user.followIngPostCount ? this.user.followIngPostCount + 1 : 1
        })

      })
        .then(() => {
          this.afs.collection('posts').doc(post.id).update(
            { ['follow-' + this.userId]: true }
          )
        })

    }
  }

  isInMyFollowingPosts() {
    try {
      return this.post.followers.filter(key => key == this.userId).length != 0;
    } catch (e) {
      return false;
    }
  }

  deleteFollowingPost(post) {

    post.followers = post.followers.filter(key => key != this.userId);

    this.afs.collection('posts').doc(post.id).update({
      followers: post.followers

    }).then(() => {
      this.afs.collection('users').doc(this.userId).update({
        followIngPostCount: this.user.followIngPostCount ? this.user.followIngPostCount - 1 : 0
      })
    }).then(() => {

      this.afs.collection('posts').doc(post.id).update({
        ['follow-' + this.userId]: firestore.FieldValue.delete()
      })
    });


  }

  async getPoint(postUser: any, type: string) {

    this.afs.collection('users').ref.where('username', '==', postUser.username).get().then((data => {
      // if (type === 'repost') {
      //   this.afs.collection('users').doc(data.docs[0].id).update({
      //     point: {
      //       totalPoint: (data.docs[0].data().point.totalPoint || 0) + 2
      //     }
      //   });
      // }
      if (type === 'like') {

        this.afs.collection('users').doc(data.docs[0].id).update({
          point: {
            totalPoint: (data.docs[0].data().point.totalPoint || 0) + 2
          }
        });

      }
      if (type === 'unlike') {
        this.afs.collection('users').doc(data.docs[0].id).update({
          point: {
            totalPoint: (data.docs[0].data().point.totalPoint || 0) - 2
          }
        });

      }
    }))


  }
  like(post) {
    if (!this.userId) {
      this.router.navigate(['/auth']);
      return;
    }
    const user = {
      firstname: this.user.firstname,
      lastname: this.user.lastname,
      profileImage: this.user.profileImage,
      username: this.user.username
    };

    this.isLiked().then((boolLike) => {
      if (!boolLike) {
        if (post.author.username !== this.user.username) {

          this.isLike = true;
          this.isLikeCount = post.likes ? post.likes + 1 : 1;
          this.cd.markForCheck();
          this.afs.collection('posts').doc(this.post.id).collection('likes').add(user).then(() => {
            this.afs.collection('posts').doc(this.post.id).update({
              valueOf: post.valueOf + 1,
              valueOf_ModifyDate: -1 * parseInt("" + (post.valueOf + 1) + post.modifyDate),
              likes: post.likes ? post.likes + 1 : 1
            });
          })
          this.afs.collection('users').ref.where('username', '==', post.author.username).get().then((snap) => {


            const message = {
              body: '<span><strong>' + this.user.firstname + ' ' + this.user.lastname + '</strong> gönderini beğendi.</span>',
              innerBody: this.user.firstname + ' ' + this.user.lastname + ' gönderini beğendi.',
              title: 'Beğeni',
              click_action: environment.domainName + "post/" + post.id,
              action: "post/" + post.id,
              postText: post.innerText,
              postUser: post.author.firstname + " " + post.author.lastname,
              image: this.user.profileImage,
              isUnseen: true,
              modifyDate: Date.now()
            };
            this.notificationService.pushNotification(message, snap.docs[0].id);
            return false;

          }).then(() => this.getPoint(post.author, 'like'))
          this.userService.userLog('post-like', this.ipAddress);
        }
      } else {
        if (post.likes) {
          this.isLikeCount = post.likes ? post.likes - 1 : 0
          this.cd.markForCheck();
          this.isLike = false;
          this.afs.collection('posts').doc(this.post.id).collection('likes').ref.where('username', '==', this.user.username).get().then(like => {
            this.afs.collection('posts').doc(this.post.id).collection('likes').doc(like.docs[0].id).delete();
          }).then(() => {

            this.afs.collection('posts').doc(this.post.id).update({
              valueOf: post.valueOf - 1,
              valueOf_ModifyDate: -1 * parseInt("" + (post.valueOf - 1) + post.modifyDate),
              likes: post.likes ? post.likes - 1 : 0
            })
          })
          if (post.author.username !== this.user.username) {
            this.getPoint(post.author, 'unlike');
            this.userService.userLog('post-unlike', this.ipAddress);
          }
        }

      }



    });





  }
  getIpAdress() {
    this.subscription.add(this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddress = data.json() }).subscribe());
  }

  isLiked(): Promise<boolean> {
    try {
      return this.afs.collection('posts').doc(this.post.id)
        .collection('likes').ref.where('username', '==', this.user.username).get().then(data => {
          if (!data.empty) {
            return true;
          }
          else {
            return false;

          }
        });
    } catch (e) {
      return new Promise((resolve) => { resolve(false); });
    }
  }



  isComment(): boolean {
    if (this.post.comments) {
      const commented = this.post.comments.filter(comment => {
        if (this.user) {
          return comment.user.username === this.user.username;
        }
      });
      return commented.length > 0 ? true : false;
    }
  }
  isRepost(): Promise<boolean> {
    try {
      return this.afs.collection('posts').doc(this.post.id)
        .collection('reposts').ref.where('username', '==', this.user.username).get().then(data => {
          if (!data.empty) {
            return true;
          }
          else {
            return false;
          }
        });
    } catch (e) {
      return new Promise((resolve) => { resolve(false); });
    }

  }
  repost(post) {

    if (!this.userId) {
      this.router.navigate(['/auth']);
      return;
    }
    this.afs.collection('posts').ref.where('repostedByUser.username', '==', this.user.username).get().then(repostUser => {
      const y = [];
      repostUser.docs.map(reposts => {
        if (((reposts.data().order) * -1) > Date.now() - 86400000) {
          y.push(reposts.data());

        }
      });
      if (y.length >= 5) {
        this.dialog.open(SaveMessageComponent, {
          width: '600px',
          data: {
            message: 'Günlük repost hakkını doldurdun, ama biz seni dinlemeye doyamadık! Yarın yeni paylaşımların için bekliyoruz :)',
            type: "update"
          }
        });

      }


      if (post.repostedByUser)
        if (post.repostedByUser.username == this.user.username) {
          return;
        }
      if (post.author.username == this.user.username) {
        return;
      }

      if (post.repostedFrom && post.repostedFrom.username == this.user.username) {
        return;
      }
      const user = {
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        profileImage: this.user.profileImage,
        username: this.user.username
      };
      let fromUser;
      if (post.repostedByUser)
        fromUser = post.repostedByUser.username;
      else
        fromUser = post.author.username;
      let fromUserKey;
      if (fromUser !== this.user.username && !post.repostedByUser) {

        this.isRepost().then((isRepo) => {
          if (!isRepo) {
            let newPost: any = {};
            Object.assign(newPost, post);
            newPost.comments = [];
            newPost.valueOf = 0;
            newPost.repost = 0;
            newPost.likes = 0;
            newPost.valueOf_ModifyDate = -1 * parseInt("0" + Date.now());
            newPost.followers = [];
            newPost.settings = post.settings;
            newPost.order = -1 * Date.now();
            newPost.author = post.repostedFrom ? post.repostedFrom : user
            newPost.repostedFrom = post.author;
            newPost.repostedByUser = user;
            delete newPost.id;
            this.getPoint(post.author, 'repost');
            this.afs.collection('posts').doc(post.id).update({
              reposts: post.reposts ? post.reposts + 1 : 1
            })
            this.afs.collection('posts').add(newPost)
              .then(() => {
                this.afs.collection('posts').doc(post.id).collection('reposts').add(user)

                this.afs.collection('users').doc(this.userId).update({ myRepost: this.user.myRepost ? this.user.myRepost + 1 : 1 })
                this.reload.emit();
                // this.afs.collection('posts').doc(post.id).ref.get().then(postt=>{
                //   this.apiService.editToSql({...postt.data(), key: postt.id}, this.userId, "corporate/updatePost");
                // })
              });
            this.afs.collection('users').ref.where('username', '==', fromUser).get().then((snap) => {


              const message = {
                body: '<span><strong>' + this.user.firstname + ' ' + this.user.lastname + '</strong> gönderini yeniden paylaştı.</span>',
                innerBody: this.user.firstname + ' ' + this.user.lastname + ' gönderini yeniden paylaştı.',
                title: 'Yeniden Paylaşım',
                click_action: environment.domainName + "post/" + post.id,
                action: "post/" + post.id,
                postText: post.innerText,
                postUser: post.author.firstname + " " + post.author.lastname,
                image: this.user.profileImage,
                isUnseen: true,
                modifyDate: Date.now()
              };
              this.notificationService.pushNotification(message, snap.docs[0].id);
              return false;
            })
          }


        })
        // this.userService.userLog('repost', this.ipAddress);


      }



    });
  }
  collapse(key) {
    const commentList = document.getElementById('collapse' + key);
    const collapseStatus = commentList.classList.contains('collapse');
    collapseStatus ? commentList.classList.remove('collapse') : commentList.classList.add('collapse');
  }

  openImage(images: any[]): void {
    let pipe = new StoragePathPipe();
    let album = [];
    images.filter((image: any) => {
      if (image.type == "image" && this.censorPhoto === false)
        album.push({
          src: pipe.transform(image.name)
        });
    })
    // open lightbox
    if (album.length > 0)
      this._lightbox.open(album);
  }

  deletePost(post) {

    const postKey = post.id;

    const isForFriend = post.settings.isOnlyFriend;

    this.afs.collection('posts').doc(postKey).delete().then(() => {
      this.afs.collection('users').doc(this.userId).update({
        myRepost: this.user.myRepost ? this.user.myRepost - 1 : 0
      })
    }).then(() => {
      this.postService.postCountDelete(this.userId, post)
    }).then(() => {
      let xx;
      let y;

      this.afs.collection('categories').ref.where('name', '==', post.rating.category).get().then((data => {

        this.afs.collection('users').doc(this.userId).ref.get().then((data2 => {
          xx = {
            [data.docs[0].data().uniqueName]: {
              point: data2.data().point[data.docs[0].data().uniqueName].point - 10
            },
            totalPoint: data2.data().point.totalPoint - 10
          }

          const a = Object.entries(data2.data().point).filter(b => {
            return b[0] !== data.docs[0].data().uniqueName && b[0] !== 'totalPoint'
          })
          a.forEach(z => {
            y = {
              [z[0]]: z[1]
            }

            Object.assign(xx, y);
          });
        })).then(() => {

          this.afs.collection('users').doc(this.userId).update({ point: xx });
          this.cd.markForCheck();
        })

      }))

    })
      .then(() => {
        this.afs.collection('weeklyPosts').ref.get().then(a => {


          let name;
          a.forEach(b => {

            let obj = {};
            const data = b.data().hashtags as Object;
            Object.entries(data).forEach(e => {
              let x;
              x = e[1]['modifyDate'].filter(item => {
                return item !== post.modifyDate;
              });
              name = e[0];
              obj = {
                ...obj,
                [e[0]]: {
                  modifyDate: x,
                  name: e[1]['name'],
                  uniqueName: e[1]['uniqueName'],
                  hashtagName: b.data().hashtagName

                }
              }
              obj[e[0]]['total'] = x.length;
            });



            this.afs.collection('weeklyPosts').doc(b.id).update({ hashtags: obj });
          });

          // let xx;
          // let y;

          // this.afs.collection('categories').ref.where('name', '==', post.rating.category).get().then((data => {

          //   this.afs.collection('users').doc(this.userId).ref.get().then((data2 => {
          //     xx = {
          //       [data.docs[0].data().uniqueName]: {
          //         point: data2.data().point[data.docs[0].data().uniqueName].point - 10
          //       },
          //       totalPoint: data2.data().point.totalPoint - 10
          //     }

          //     const a = Object.entries(data2.data().point).filter(b => {
          //       return b[0] !== data.docs[0].data().uniqueName && b[0] !== 'totalPoint'
          //     })
          //     a.forEach(z => {
          //       y = {
          //         [z[0]]: z[1]
          //       }

          //       Object.assign(xx, y);
          //     });
          //   })).then(() => {

          //     this.afs.collection('users').doc(this.userId).update({ point: xx });
          //     this.cd.markForCheck();
          //   })

          // }))

        })

      });
    this.userService.userLog('delete-post', this.ipAddress);





  }

  silencedUser(post) {
    if (!this.userId) {
      this.router.navigate(['/auth']);
      return;
    }



    this.afs.collection('users').doc(this.userId).collection('silencedUser').doc(post.user).set({
      username: post.author.username,
      firstname: post.author.firstname,
      lastname: post.author.lastname,
      profileImage: post.author.profileImage,
      userKey: post.user

    }).then(() => {
      this.reload.emit();
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "Kullanıcıyı sessize aldın.",
          type: "update"
        }
      });
    });
    this.userService.userLog('silenced-user', this.ipAddress);
  }


}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post-item/post-body/post-body.component.ts